import axios from "axios";

//OLD
/*
const homePageDataQuery = `
query HomePageData($orgId: String) {
        homePageData(orgId: $orgId) {
          mentors {
            _id
            name
            title
            keywords
            transcript
            mentorUrl
            thumbnail
          }
          panels {
            _id
            org
            subject
            mentors
            title
            subtitle
            panelUrl
          }
        }
      }
`;
*/
//NEW
const homePageDataQuery = `
query HomePageData($orgId: String) {
        homePageData(orgId: $orgId) {
          mentors {
            _id
            name
            title
            keywords
            transcript
            mentorUrl
            thumbnail
          }
          panels {
            _id
            org
            subject
            mentors
            title
            subtitle
            panelUrl
          }
          activeMentorIds
        }
      }
`;

export async function fetchHomePageData(
  orgId = process.env.REACT_APP_PATHWAYS_ORG_ID,
) {
  const graphqlEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT;
  if (!graphqlEndpoint) {
    throw new Error("GraphQL endpoint is not defined.");
  }

  const gqlRes = await axios.post(graphqlEndpoint, {
    query: homePageDataQuery,
    variables: {
      orgId: orgId,
    },
  });

  if (gqlRes.status !== 200) {
    throw new Error(`HomePageData load failed: ${gqlRes.statusText}}`);
  }
  if (gqlRes.data.errors) {
    throw new Error(
      `errors reponse to homePageData query: ${JSON.stringify(
        gqlRes.data.errors
      )}`
    );
  }
  if (!gqlRes.data.data) {
    throw new Error(
      `no data in non-error reponse: ${JSON.stringify(gqlRes.data)}`
    );
  }
  return gqlRes.data.data.homePageData;
}
